var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"commoditysearch"},[_c('div',{style:({
      background: _vm.datas.backColor,
      'border-style': _vm.datas.borderStyle,
      'border-color': _vm.datas.borderColor,
      'border-width': _vm.datas.borderLineWeight + 'px',
      'border-radius': _vm.datas.borderRadius + 'px',
      'padding-top': _vm.datas.paddingTop + 'px',
      'padding-bottom': _vm.datas.paddingBottom + 'px',
      'padding-left': _vm.datas.paddingLeft + 'px',
      'padding-right': _vm.datas.paddingRight + 'px',
      'margin-top': _vm.datas.marginTop + 'px',
      'margin-bottom': _vm.datas.marginBottom + 'px',
      'margin-left': _vm.datas.marginLeft + 'px',
      'margin-right': _vm.datas.marginRight + 'px',
    })},[_c('section',{staticClass:"search_con"},[(_vm.datas.styleType != 1)?_c('div',{staticClass:"search_user_img"},[_c('i',{staticClass:"iconfont icon-touxiang"})]):_vm._e(),_c('div',{staticClass:"search_input_con",style:({
          'background-color': _vm.datas.searchBgColor,
          border: '1px solid ' + _vm.datas.searchBorderColor,
        })},[_c('i',{staticClass:"iconfont icon-sousuo",style:({
            color: _vm.datas.searchIconColor,
            'font-size': _vm.datas.wordSize + 'px',
            'margin-right': '5px',
          })}),_c('span',{style:({
            color: _vm.datas.wordColor,
            'font-size': _vm.datas.wordSize + 'px',
            'font-weight': _vm.datas.isBold ? 'bold' : 'normal',
            'font-style': _vm.datas.isTilt ? 'italic' : 'normal',
            'text-decoration': _vm.datas.isUnderLine ? 'underline' : 'none',
          })},[_vm._v(_vm._s(_vm.datas.searchTitle))])])])]),_vm._t("deles")],2)}
var staticRenderFns = []

export { render, staticRenderFns }